<template>
  <div>
    <div class="topbanner" >
      <div class="topleft">
        <p>已连续签到{{ unseengt }}天</p>
      </div>
      <div class="topright" @click="giusewrdetrhr">
        <img src="../../assets/image/bnjmwjm.png" alt="">
        <span>{{ credit }}  <md-icon name="arrow-right" size="md"></md-icon></span>
      </div>
    </div>
    <div class="jinuser" v-if="list.length>0">
      <div class="jntop">
        <div class="jkejkkr">
          <span>签到领积分</span>
          <!-- <p>
             <span>签到提醒</span>
             <md-switch
               v-model="isActive"
               @change="handler(isActive)"
             ></md-switch>
           </p> !-->
        </div>
      </div>
      <div class="timlist">
        <div class="lsiubhrhjhjr">
          <div class="iukinmf" v-for="(item,index) in list" :key="index">
            <img src="../../assets/image/jinbi.png" alt="" v-if="!item.isFinish">
            <img src="../../assets/image/ling.png" alt="" v-if="item.isFinish">
            <span :class="item.canTouch?'jwjjww':''" v-if="!item.canTouch">{{ index + 1 }}天</span>
            <span :class="item.canTouch?'jwjjww':''" v-if="item.canTouch">今天</span>
            <div class="jewjjr" v-if="item.canTouch">
              <span>+{{ item.credit }}</span>
            </div>
            <div v-if="!item.isFinish" class="ikekkr">
              <span>{{ item.credit }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="benjrj">
        <div :class="idbtn?'lingbtn':'jejje'" @click="qindao">
          <md-activity-indicator
            v-if="loading"
            class="md-activity-indicator-css"
            type="carousel"
            :size="15"
            color="#fff"
            text-color="#fff"
          ></md-activity-indicator>
          <span v-else>签到</span>
        </div>
      </div>
    </div>
    <!-- 商城兑换 -->
    <!-- <div class="jinshangcheng" v-if="list.length>0" @click="ginrnnt"></div> -->
    <div class="jinlikst" v-if="bottomlist.length>0">
      <div class="jintigejmr">
        <span>做任务赢积分</span>
      </div>
      <div class="jinisionr" v-for="(item,index) in bottomlist" :key="index">
        <div class="jinlkejjr">
          <img :src="item.picUrl" alt="">
          <div class="jdiwknkf">
            <span class="jinnbannre">{{ item.name }}</span>
            <span>+{{ item.credit }}积分</span>
          </div>
        </div>
        <div class="mkkweklmq">
          <span v-if="!item.isFinish" style="color: #F93917">待完成</span>
          <span v-if="item.isFinish">已完成</span>
        </div>
      </div>
    </div>
    <md-landscape v-model="showPic">
      <div class="kwekker">
        <p>
          获得
          <span>{{ geyhbrj }}</span>
          积分
        </p>
        <div class="wjjerjr" @click="showPic=false">
          <span>完成</span>
        </div>
      </div>
    </md-landscape>
  </div>
</template>

<script>
import {Switch, Toast, Icon, ActivityIndicator, Landscape} from 'mand-mobile'
import {getUrlKey} from '../../until/getUrlcode'
import wx from 'weixin-js-sdk';

export default {
  name: "uisejifen",
  components: {
    [Switch.name]: Switch,
    [Landscape.name]: Landscape,
    [ActivityIndicator.name]: ActivityIndicator,
  },
  data() {
    return {
      jejjr: 0,
      showPic: false,
      isActive: false,
      list: [],
      credit: 0,
      findvaluss: [],
      bottomlist: [],
      datalehty: 0,
      idbtn: false,
      unseengt: 0,
      loading: false,
      geyhbrj: 0,
    }
  },
  activated() {
    if (localStorage.getItem('fljjr')) {
      localStorage.removeItem('fljjr')
      this.getcreduit()
    }
    if (getUrlKey("cnm", window.location.href)) {
      Toast.loading('加载中...');
      // debugger
      localStorage.setItem('mupressMobiltoken', getUrlKey("cnm", window.location.href));
      var that = this;
      setTimeout(function () {
        that.getsywbe(getUrlKey("shopkey", window.location.href));
      }, 20)
    } else if(localStorage.getItem('mupressMobiltoken')){
      Toast.loading('加载中....');
      this.getSignTaskList();
    }else if(localStorage.getItem('headerParams')){
      localStorage.setItem('mupressMobiltoken',JSON.parse(localStorage.getItem('headerParams')).Authorization);
      Toast.loading('加载中...');
      var that = this;
      setTimeout(function () {
        that.getsywbe(JSON.parse(localStorage.getItem('headerParams')).shopkey);
      }, 20)
    }else {
      Toast.loading('加载中...');
      if (getUrlKey("from", window.location.href) && getUrlKey("from", window.location.href) == 'app') {
        HookUp.postMessage(JSON.stringify({
          code: 401
        }));
      } else {
        wx.miniProgram.navigateBack({})
        wx.miniProgram.navigateTo({url: '/pages/login/login'})
      }
    }
  },
  methods: {
    ginrnnt() {
      this.isShowShop()
    },
    getsywbe(appCode){
      const par={
        appCode:(appCode&&appCode!=undefined)?appCode:'1572677768'
      }
      this.http
        .APIASK(this.ports.getStoreInfo, 'get', par)
        .then((res) => {
          localStorage.setItem('shopkey', JSON.stringify(res));
          this.getSignTaskList()
        })
    },
    giusewrdetrhr() {
      if (getUrlKey("from", window.location.href) && getUrlKey("from", window.location.href) == 'app') {
        this.$router.push({
          name: 'Jinfedetaile', query: {
            from: 'app'
          }
        })
      } else {
        this.$router.push({name: 'Jinfedetaile'})
      }

    },
    isShowShop() {
      this.ajcon.AJcon(this.ports.isShowShop, 'post').then(res => {
        if (res) {
          if (getUrlKey("from", window.location.href) && getUrlKey("from", window.location.href) == 'app') {
            this.$router.push({
              name: 'Jinfeduihuan', query: {
                from: 'app'
              }
            })
          }else{
            this.$router.push({name: 'Jinfeduihuan'})
          }
        } else {
          Toast.info('活动暂未开启,敬请期待！')
        }
        console.log(res)
      }).catch(err => {
        Toast.hide();

      })
    },
    getcreduit() {
      this.ajax.AJAx(this.ports.getUserCredit, 'post').then(res => {
        this.credit = res.credit;
        Toast.hide();
        this.loading = false;
      }).catch(err => {
        Toast.hide();
        this.loading = false;
      })
    },
    handler(active) {
      console.log(active)
    },
    getSignTaskList() {
      this.ajax.AJAx(this.ports.getSignTaskList, 'post',).then(res => {
        // debugger
        this.list = res.signTaskResponses;
        this.idbtn = !res.todayFinish;
        this.isbtn(this.list);
        this.getlkisg();
        this.getcreduit();
      }).catch(err => {
        Toast.hide()
      })
    },
    isbtn(list) {
      const findvalu = list.filter(val => {
        return val.canTouch
      })
      const kjekjek = list.filter(val => {
        return val.isFinish
      })
      this.unseengt = kjekjek.length;
      if (findvalu.length > 0) {
        const findvaluss = findvalu.filter(val => {
          return !val.todayFinish
        })
        this.findvaluss = findvaluss
      }
    },
    getlkisg() {
      this.ajax.AJAx(this.ports.getOtherTaskList, 'post',).then(res => {
        this.bottomlist = res
        Toast.hide()
      }).catch(err => {
        Toast.hide()
      })
    },
    kewkker() {
      if (getUrlKey("from", window.location.href) && getUrlKey("from", window.location.href) == 'app') {
        HookUp.postMessage(JSON.stringify({
          code: 4,
          data: '',
          msg: ''
        }));
      }
    },
    qindao() {
      if (this.idbtn) {
        this.loading = true;
        Toast.loading('请稍等...')
        const par = {
          id: this.findvaluss[0].id
        }
        this.ajax.AJAx(this.ports.doSignTask, 'post', par).then(res => {
          this.showPic = true;
          this.geyhbrj = this.findvaluss[0].credit;
          this.getSignTaskList();
          this.kewkker();
        }).catch(err => {
          this.loading = false;
          Toast.hide()
        })
      }
    }
  }
}
</script>
<style>
.md-landscape .md-icon.md-landscape-close {
  display: none;
}
</style>
<style lang="less" scoped>
.kwekker {
  width: 100%;
  height: 4.98rem;
  background: url("../../assets/image/suchhe.png") no-repeat center;
  background-size: contain;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    font-size: 0.32rem;
    color: #333333;
    margin-top: 2.25rem;
    display: flex;
    align-items: center;

    span {
      color: #F9311A;
      font-size: 0.6rem;
      font-weight: bold;
      margin: 0 0.1rem;
    }
  }

  .wjjerjr {
    width: 3rem;
    height: 0.92rem;
    background: linear-gradient(270deg, #E8604E 0%, #E22C1C 100%);
    box-shadow: 0px 0.04rem 0.12rem -0.02rem rgba(0, 0, 0, 0.2);
    border-radius: 0.48rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 0.32rem;
    margin-top: 0.5rem;
  }
}

.topbanner {
  width: 100%;
  height: 3.12rem;
  background: url("../../assets/image/jifenbanner.png") no-repeat center;
  background-size: cover;
  display: flex;
  justify-content: space-between;

  .topleft {
    font-size: 0.32rem;
    color: white;
    margin-left: 0.4rem;
    margin-top: 0.45rem;
    height: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      text-align: left;
      font-weight: 400;
    }

    span {
      font-size: 0.24rem;
    }
  }

  .topright {
    width: 2.28rem;
    height: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.02rem solid white;
    margin-right: 0.4rem;
    margin-top: 0.45rem;
    border-radius: 0.43rem;
    color: white;

    img {
      width: 0.48rem;
    }

    span {
      font-size: 0.36rem;
      font-weight: bold;
    }
  }
}

.jinuser {
  width: 92%;
  margin-left: 4%;
  height: 4.7rem;
  margin-top: -1.5rem;
  background: url("../../assets/image/jinbannerb.png") no-repeat center;
  background-size: cover;

  .jntop {
    width: 100%;
    height: 1.03rem;

    .jkejkkr {
      width: 92%;
      margin-left: 4%;
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: space-between;

      span {
        font-size: 0.32rem;
        font-weight: bold;
        color: #333333;
      }

      p {
        display: flex;
        align-items: center;

        .md-switch {
          height: 0.15rem;
          width: 0.6rem;
        }

        .md-switch:before {
          height: 0.15rem;
          width: 0.6rem;
        }

        .md-switch:after {
          top: -0.08rem;
          height: 0.3rem;
          width: 0.3rem;
          background-color: rgb(175, 175, 175);
        }

        .md-switch.active {
          background-color: rgb(254, 220, 217);
        }

        .md-switch.active:after {
          background-color: rgb(233, 40, 36);
        }

        span {
          color: #999999;
          font-size: 0.28rem;
          padding-right: 0.1rem;
        }
      }
    }

  }

  .timlist {
    width: 100%;
    height: 2.3rem;
    display: flex;
    align-items: flex-end;

    .lsiubhrhjhjr {
      width: 92%;
      margin-left: 4%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .iukinmf {
        width: 0.72rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 0.24rem;
        color: #333333;
        font-weight: 400;
        position: relative;

        img {
          width: 100%;
          height: auto;
          margin-bottom: 0.1rem;
        }

        .jwjjww {
          color: #999999;
        }

        .jewjjr {
          position: absolute;
          width: 0.68rem;
          height: 0.68rem;
          top: -0.58rem;
          background: url("../../assets/image/jinfenr.png") no-repeat center;
          background-size: cover;
          color: white;
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            font-size: 0.2rem;
            margin-top: -0.15rem;
          }
        }

        .ikekkr {
          position: absolute;
          width: 0.4rem;
          height: 0.4rem;
          display: flex;
          align-items: center;
          justify-content: center;
          top: 0.12rem;
          color: #FFF7C5;
          font-size: 0.2rem;
        }
      }
    }
  }

  .benjrj {
    width: 100%;
    height: 1.2rem;
    display: flex;
    justify-content: center;
    margin-top: -0.1rem;

    .lingbtn {
      width: 3.14rem;
      height: 0.76rem;
      background: linear-gradient(270deg, #E8604E 0%, #E22C1C 100%);
      box-shadow: 0px 0.04rem 0.12rem -0.02rem rgba(0, 0, 0, 0.2);
      border-radius: 0.48rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.32rem;
      color: white;
    }

    .jejje {
      width: 3.14rem;
      height: 0.76rem;
      background: #B8B8B8;
      box-shadow: 0px 0.04rem 0.12rem -0.02rem rgba(0, 0, 0, 0.2);
      border-radius: 0.48rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.32rem;
      color: white;
    }
  }
}

.jinshangcheng {
  width: 92%;
  height: 1.56rem;
  background: url("../../assets/image/jinfendine.png") no-repeat center;
  background-size: cover;
  margin: 0.2rem 4%;
}

.jinlikst {
  width: 92%;
  margin-left: 4%;
  border-radius: 0.08rem;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 0.04rem 0.06rem -0.04rem rgba(0, 0, 0, 0.12);
  margin-bottom: 0.5rem;

  .jintigejmr {
    width: 92%;
    margin-left: 4%;
    height: 0.9rem;
    display: flex;
    align-items: center;
    font-size: 0.32rem;
    font-weight: bold;
  }

  .jinisionr {
    width: 92%;
    margin-left: 4%;
    height: 1.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -0.1rem;

    .jinlkejjr {
      display: flex;
      align-items: center;
      height: 0.6rem;

      img {
        width: 0.6rem;
        height: 0.6rem;
        margin-right: 0.16rem;
      }

      .jdiwknkf {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        font-weight: 400;
        color: #999999;
        font-size: 0.24rem;

        .jinnbannre {
          font-size: 0.28rem;
          color: #333333;
          margin-top: -0.02rem;
          margin-bottom: 0.1rem;
        }
      }
    }

    .mkkweklmq {
      color: #999999;
      font-size: 0.24rem;
    }

    .kkdek {
      width: 1.48rem;
      height: 0.6rem;
      background: #B8B8B8;
      box-shadow: 0px 0.04rem 0.12rem -0.02rem rgba(0, 0, 0, 0.2);
      border-radius: 0.3rem;
      color: #FFFFFF;
      font-size: 0.24rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
